module.exports = __webpack_public_path__ + "e2a6f8d9.png";